import styled from "@emotion/styled"

const HeroScrollCaseDemoMobile = styled.div`
  background-color: ${({ theme }) => theme.palette.gray[50]};
  border: 4px solid ${({ theme }) => theme.palette.common.white};
  aspect-ratio: 15 / 32;
  border-radius: 15px;
  max-width: 320px;
  display: flex;
  overflow: hidden;
  box-shadow: 0px 6px 25px -15px #000000D9;

  & > * {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
export default HeroScrollCaseDemoMobile
